export const printCustomerPayment = (paymentData) => {
  const printWindow = window.open("", "_blank");

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("en-GB");
  };

  const formatTime = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const money = (value) => {
    if (value === null || value === undefined || value === "") return "0.00";
    const num = Number(value);
    return Number.isNaN(num) ? String(value) : num.toFixed(2);
  };

  const receiptNo = paymentData?.id ?? paymentData?.receiptNumber ?? "-";
  const paymentDate = paymentData?.payment_date || paymentData?.created_at || new Date();
  const customerName =
    paymentData?.customer_details?.name ||
    paymentData?.customer_name ||
    paymentData?.customer ||
    "-";
  const currency =
    paymentData?.currency_details?.title ||
    paymentData?.currency ||
    paymentData?.currency_symbol ||
    "AFG";
  const account = paymentData?.account_details?.name || paymentData?.account || "-";
  const amount = paymentData?.amount ?? paymentData?.paid_amount ?? "0.00";
  const exchangeRate = paymentData?.exchange_rate ?? "1";
  const convertedAmount =
    paymentData?.converted_amount ?? paymentData?.amount_converted ?? money(amount);
  const notes = paymentData?.notes || paymentData?.note || "";

  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8" />
      <title>Customer Payment Receipt</title>
      <style>
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }

        html, body {
          background: #fff;
          color: #000;
          font-family: "Courier New", monospace;
          font-size: 12px;
          line-height: 1.35;
          margin: 0;
          padding: 0;
        }

        body {
          width: 148mm;
          height: 210mm;
          padding: 6mm 10mm 8mm;
          overflow: hidden;
        }

        .receipt {
          width: 100%;
          max-width: 128mm;
          margin: 0 auto;
        }

        .center {
          text-align: center;
        }

        .company {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 1px;
        }

        .contact {
          font-size: 10px;
          margin-bottom: 6px;
        }

        .title {
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.8px;
          margin: 6px 0 10px;
        }

        .dash {
          border-top: 1px dashed #000;
          margin: 7px 0;
        }

        .row {
          display: flex;
          justify-content: space-between;
          gap: 10px;
          margin: 3px 0;
          font-size: 12px;
        }

        .label {
          white-space: nowrap;
        }

        .value {
          text-align: right;
          word-break: break-word;
          padding-left: 8px;
          flex: 1;
        }

        .footer {
          margin-top: 16px;
          text-align: center;
          font-size: 11px;
        }

        .small {
          font-size: 10px;
        }

        @page {
          size: 148mm 210mm;
          margin: 0;
        }

        @media print {
          html, body {
            width: 148mm;
            height: 210mm;
          }

          body {
            width: 148mm;
            height: 210mm;
            padding: 6mm 10mm 8mm;
            overflow: hidden;
          }

          .receipt {
            max-width: 128mm;
            margin: 0 auto;
          }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="center">
          <div class="company">Habib Gilaman</div>
          <div class="contact">0767080919 - 0767080919</div>
          <div class="title">PAYMENT RECEIPT</div>
        </div>

        <div class="dash"></div>

        <div class="row">
          <span class="label">Receipt:</span>
          <span class="value">${receiptNo}</span>
        </div>
        <div class="row">
          <span class="label">Date:</span>
          <span class="value">${formatDate(paymentDate)}</span>
        </div>
        <div class="row">
          <span class="label">Time:</span>
          <span class="value">${formatTime(paymentDate)}</span>
        </div>

        <div class="dash"></div>

        <div class="row">
          <span class="label">Customer:</span>
          <span class="value">${customerName}</span>
        </div>
        <div class="row">
          <span class="label">Amount:</span>
          <span class="value">${money(amount)} ${currency}</span>
        </div>
        <div class="row">
          <span class="label">Currency:</span>
          <span class="value">${currency}</span>
        </div>
        <div class="row">
          <span class="label">Account:</span>
          <span class="value">${account}</span>
        </div>
        <div class="row">
          <span class="label">Exchange Rate:</span>
          <span class="value">${exchangeRate}</span>
        </div>
        <div class="row">
          <span class="label">Converted:</span>
          <span class="value">${money(convertedAmount)} ${currency}</span>
        </div>

        ${
          notes
            ? `
          <div class="dash"></div>
          <div class="row">
            <span class="label">Notes:</span>
            <span class="value">${notes}</span>
          </div>
        `
            : ""
        }

        <div class="dash"></div>

        <div class="footer">
          Thank you!<br />
          ${new Date().getFullYear()} (c) Habib Gilaman<br />
          <span class="small">Powered by Afghan Cosmos IT Solutions</span>
        </div>
      </div>

      <script>
        window.onload = function () {
          setTimeout(function () {
            window.print();
            window.close();
          }, 300);
        };
      </script>
    </body>
    </html>
  `;

  printWindow.document.write(printContent);
  printWindow.document.close();
};
